import { SelectItem } from '@components/inputs/select/Select.component';
import I18n from '@utils/i18n.utils';

export enum AuditCollectContainerFrequency {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export namespace AuditCollectContainerFrequency {
  export const selectItems = (): SelectItem[] => [
    {label: I18n.t('audits.audit.collect.monthly'), value: AuditCollectContainerFrequency.MONTHLY},
    {label: I18n.t('audits.audit.collect.weekly'), value: AuditCollectContainerFrequency.WEEKLY},
    {label: I18n.t('audits.audit.collect.daily'), value: AuditCollectContainerFrequency.DAILY}
  ];
}

export enum AuditType {
  CONTAINER = 'CONTAINER',
  OBSERVATION = 'OBSERVATION',
  MAP = 'MAP'
}

export namespace AuditType {
  export const selectItems = (): SelectItem[] => [
    {label: I18n.t('audits.audit.types.container'), value: AuditType.CONTAINER},
    {label: I18n.t('audits.audit.types.observation'), value: AuditType.OBSERVATION},
    {label: I18n.t('audits.audit.types.map'), value: AuditType.MAP}
  ];
}